const positiveId = (value) => ["string", "number"].includes(typeof value)
  && Number.isSafeInteger(Number(value)) && Number(value) > 0 ? Number(value) : null;
const ids = (values) => [...new Set(values.map(positiveId).filter(Boolean))];

// supplier_id on a supplier is its commercial code, not a database identity.
export const supplierIdentityIds = (supplier) => supplier && typeof supplier === "object"
  ? ids([supplier.id, supplier.canonical_supplier_id, ...(supplier.supplier_member_ids || []),
    ...(supplier.merged_suppliers || []).map((member) => member.id)])
  : ids([supplier]);

// An item link retains its physical supplier_id and product reference. Group
// membership only changes which selectors and article filters can display it.
export const itemSupplierMatches = (link, supplier) => {
  const selected = new Set(supplierIdentityIds(supplier));
  return ids([link?.supplier_id, link?.canonical_supplier_id, ...(link?.supplier_member_ids || []),
    ...supplierIdentityIds(link?.supplier)]).some((id) => selected.has(id));
};

export const itemMatchesSupplier = (item, supplier) => (item?.item_suppliers || [])
  .some((link) => itemSupplierMatches(link, supplier));

export const findItemSupplierRelation = (item, supplier) => {
  const links = item?.item_suppliers || [];
  const selectedId = positiveId(supplier && typeof supplier === "object" ? supplier.id : supplier);
  return links.find((link) => selectedId && positiveId(link.supplier_id) === selectedId)
    || links.find((link) => itemSupplierMatches(link, supplier)) || null;
};
